module.exports = __webpack_public_path__ + "img/give.3de1c586.png";